(function (runtime) {
    "use strict";

    var STATUS_PATH = "wishlist/status";
    var ADD_PATH = "wishlist/add";
    var REMOVE_PATH = "wishlist/remove";
    var RETURN_KEY = "nkWishlistReturn";
    var RETURN_MAX_AGE_MS = 15 * 60 * 1000;

    function isClosed(value) {
        return value && (value.status === 404 || value.kind === "not_found");
    }

    function setPressed(state, pressed) {
        state.button.classList.toggle("is-on", pressed);
        state.button.setAttribute("aria-pressed", pressed ? "true" : "false");
        state.button.setAttribute("aria-label", state.button.dataset.nkWishlistAddLabel);
    }

    function showNotice(state, kind) {
        var status = state.status;
        if (!status) { return; }
        if (state.noticeTimer) { runtime.clearTimeout(state.noticeTimer); }
        status.textContent = "";
        if (kind === "saved") {
            status.appendChild(state.document.createTextNode(state.button.dataset.nkWishlistSaved));
            status.appendChild(state.document.createTextNode(" · "));
            var view = state.document.createElement("a");
            view.setAttribute("href", state.button.dataset.nkWishlistAccountUrl);
            view.textContent = state.button.dataset.nkWishlistView;
            status.appendChild(view);
        } else {
            status.textContent = kind === "removed"
                ? state.button.dataset.nkWishlistRemoved
                : state.button.dataset.nkWishlistFailed;
        }
        status.hidden = false;
        state.noticeTimer = runtime.setTimeout(function () {
            status.hidden = true;
            status.textContent = "";
        }, 3000);
    }

    function hasReturnFlag() {
        if (!runtime.location || !runtime.URL) { return false; }
        return new runtime.URL(runtime.location.href).searchParams.get("nk_wish") === "1";
    }

    function clearReturnFlag() {
        if (!runtime.history || !hasReturnFlag()) { return; }
        var url = new runtime.URL(runtime.location.href);
        url.searchParams.delete("nk_wish");
        runtime.history.replaceState(runtime.history.state, "", url.pathname + url.search + url.hash);
    }

    function rememberLogin(state) {
        try {
            runtime.sessionStorage.setItem(RETURN_KEY,
                JSON.stringify({code: state.code, at: Date.now()}));
        } catch (_error) {
            // 保存できない環境では、ログイン後にハートを押し直してもらう。
        }
    }

    function takeReturnIntent(state) {
        if (!hasReturnFlag()) { return false; }
        var intent = null;
        try {
            var stored = runtime.sessionStorage.getItem(RETURN_KEY);
            runtime.sessionStorage.removeItem(RETURN_KEY);
            if (stored) { intent = JSON.parse(stored); }
        } catch (_error) {
            // 読めない記録を根拠に自動追加しない。
        } finally {
            clearReturnFlag();
        }
        var age = intent && Date.now() - intent.at;
        return Boolean(intent && intent.code === state.code && Number.isFinite(intent.at)
            && Number.isFinite(age)
            && age >= 0 && age <= RETURN_MAX_AGE_MS);
    }

    function drain(state) {
        if (state.pending || state.closed || state.suspended || !state.ready) { return state.pending; }
        state.pending = (async function () {
            while (state.desired !== state.confirmed && !state.closed) {
                var target = state.desired;
                var revision = state.revision;
                try {
                    var result = await state.proxy.post(target ? ADD_PATH : REMOVE_PATH, {
                        body: {code: state.code}
                    });
                    if (revision !== state.revision) { return; }
                    if (!result || result.saved !== target) {
                        throw result || new TypeError("wishlist update failed");
                    }
                    state.confirmed = target;
                } catch (error) {
                    if (revision !== state.revision) { return; }
                    state.desired = state.confirmed;
                    setPressed(state, state.confirmed);
                    if (isClosed(error)) {
                        state.closed = true;
                        state.button.disabled = true;
                        return;
                    }
                    showNotice(state, "failed");
                    return;
                }
            }
            if (!state.closed) { showNotice(state, state.confirmed ? "saved" : "removed"); }
        })().finally(function () {
            state.pending = null;
            if (state.resumeAfterPending && !state.suspended) {
                state.resumeAfterPending = false;
                initializeMember(state);
                return;
            }
            if (state.desired !== state.confirmed && !state.closed) { drain(state); }
        });
        return state.pending;
    }

    async function initializeMember(state, toggleAfterLoad) {
        var revision = ++state.revision;
        state.ready = false;
        state.known = false;
        state.button.disabled = true;
        try {
            var result = await state.proxy.get(STATUS_PATH, {query: {code: state.code}});
            if (revision !== state.revision || state.suspended) { return; }
            if (!result || typeof result.saved !== "boolean") {
                throw result || new TypeError("wishlist status failed");
            }
            state.confirmed = result.saved;
            state.desired = result.saved;
            state.known = true;
            setPressed(state, result.saved);
            if (state.autoRequested) {
                state.autoRequested = false;
                state.desired = true;
                setPressed(state, true);
                var addPromise = Promise.resolve(state.proxy.post(ADD_PATH, {
                    body: {code: state.code}
                }));
                state.autoPending = addPromise;
                var added;
                try {
                    added = await addPromise;
                } finally {
                    if (state.autoPending === addPromise) { state.autoPending = null; }
                    if (state.resumeAfterPending && !state.suspended && !state.pending) {
                        state.resumeAfterPending = false;
                        initializeMember(state);
                    }
                }
                if (revision !== state.revision || state.suspended) { return; }
                if (!added || added.saved !== true) {
                    throw added || new TypeError("wishlist add failed");
                }
                state.confirmed = true;
                showNotice(state, "saved");
            }
            state.ready = true;
            state.button.disabled = false;
            if (toggleAfterLoad) {
                state.desired = !state.confirmed;
                setPressed(state, state.desired);
                drain(state);
            }
        } catch (error) {
            if (revision !== state.revision || state.suspended) { return; }
            state.autoRequested = false;
            state.desired = state.confirmed;
            setPressed(state, state.confirmed);
            if (isClosed(error)) {
                state.closed = true;
                return;
            }
            state.ready = true;
            state.button.disabled = false;
            showNotice(state, "failed");
        }
    }

    function openGuestDialog(state) {
        if (state.dialog && typeof state.dialog.showModal === "function") {
            if (!state.dialog.open) { state.dialog.showModal(); }
            return;
        }
        rememberLogin(state);
        runtime.location.href = state.button.dataset.nkWishlistLoginUrl;
    }

    function init(root, options) {
        if (!root || !root.querySelector) { return null; }
        var button = root.querySelector("[data-nk-wishlist-code]");
        if (!button || button.dataset.nkWishlistBound === "1") { return null; }
        button.dataset.nkWishlistBound = "1";
        var settings = options || {};
        var state = {
            button: button,
            code: button.dataset.nkWishlistCode,
            status: root.querySelector("[data-nk-wishlist-status]"),
            dialog: root.querySelector("[data-nk-wishlist-dialog]"),
            document: settings.document || runtime.document,
            proxy: settings.proxy || runtime.NKAppProxy,
            confirmed: false,
            desired: false,
            known: false,
            ready: false,
            closed: false,
            pending: null,
            autoPending: null,
            autoRequested: false,
            noticeTimer: null,
            revision: 0,
            suspended: false,
            resumeAfterPending: false
        };
        state.autoRequested = takeReturnIntent(state);
        if (state.dialog) {
            var dismiss = root.querySelector("[data-nk-wishlist-dismiss]");
            if (dismiss) {
                dismiss.addEventListener("click", function () { state.dialog.close(); });
            }
            state.dialog.addEventListener("close", function () { button.focus(); });
            var signIn = root.querySelector("[data-nk-wishlist-signin]");
            if (signIn) {
                signIn.addEventListener("click", function () { rememberLogin(state); });
            }
        }
        button.addEventListener("click", function () {
            if (state.closed) { return; }
            if (button.dataset.nkWishlistLoggedIn !== "true") {
                openGuestDialog(state);
                return;
            }
            if (!state.ready) { return; }
            if (!state.known) {
                initializeMember(state, true);
                return;
            }
            state.desired = !state.desired;
            setPressed(state, state.desired);
            drain(state);
        });
        if (button.dataset.nkWishlistLoggedIn === "true") {
            if (state.proxy && typeof state.proxy.get === "function"
                    && typeof state.proxy.post === "function") {
                initializeMember(state);
            } else {
                state.ready = true;
                showNotice(state, "failed");
            }
        }
        if (typeof runtime.addEventListener === "function") {
            runtime.addEventListener("pagehide", function () {
                state.suspended = true;
                state.ready = false;
                state.revision += 1;
                state.resumeAfterPending = Boolean(state.pending || state.autoPending);
                if (state.noticeTimer) { runtime.clearTimeout(state.noticeTimer); }
                if (state.status) { state.status.hidden = true; }
                if (button.dataset.nkWishlistLoggedIn === "true") { button.disabled = true; }
            });
            runtime.addEventListener("pageshow", function (event) {
                if (!event.persisted) { return; }
                state.suspended = false;
                state.closed = false;
                if (button.dataset.nkWishlistLoggedIn === "true") {
                    if (state.pending || state.autoPending) {
                        state.resumeAfterPending = true;
                    } else {
                        state.resumeAfterPending = false;
                        initializeMember(state);
                    }
                }
            });
        }
        return state;
    }

    function autoInit(scope) {
        var documentRef = scope || runtime.document;
        if (!documentRef || !documentRef.querySelectorAll) { return; }
        Array.prototype.forEach.call(documentRef.querySelectorAll(".nk-product"), function (root) {
            init(root);
        });
    }

    var NKWishlist = {init: init};
    if (typeof window !== "undefined") { window.NKWishlist = NKWishlist; }
    if (typeof module !== "undefined" && module.exports) { module.exports = NKWishlist; }
    if (runtime.document) {
        if (runtime.document.readyState === "loading") {
            runtime.document.addEventListener("DOMContentLoaded", function () { autoInit(); }, {once: true});
        } else {
            autoInit();
        }
        runtime.document.addEventListener("shopify:section:load", function (event) {
            autoInit(event.target);
        });
    }
})(typeof window !== "undefined"
    ? window
    : (typeof globalThis !== "undefined" ? globalThis : this));
